import { render, staticRenderFns } from "./InceptionAssessmentOverallWrapper.vue?vue&type=template&id=0652d932&scoped=true"
import script from "./InceptionAssessmentOverallWrapper.vue?vue&type=script&lang=ts"
export * from "./InceptionAssessmentOverallWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0652d932",
  null
  
)

export default component.exports